import React from 'react'
import App from './App'
import i18n from './i18n'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
)
